import { Platform } from 'react-native'
import { CardStyleInterpolators, TransitionSpecs } from '@react-navigation/stack'

import { colors, typography, adaptive } from '@sart/styles'

export const stackNavigationProps = {
  screenOptions: {
    headerTintColor: colors.darkCharcoal,
    headerTitleStyle: {
      fontFamily: typography.defaultFontFamily,
      fontSize: 20,
      fontWeight: '500',
      color: colors.white
    },
    headerStyle: {
      backgroundColor: colors.darkCharcoal,
    },
    headerBackTitleStyle: {
      fontFamily: typography.defaultFontFamily,
      fontSize: 15,
      fontWeight: '500',
      color: colors.trivial
    },
    contentStyle: {
      ...Platform.select({
        android: {
          elevation: 0
        },
        ios: {
          shadowColor: 'transparent',
          shadowOpacity: 0,
          shadowRadius: 0,
          shadowOffset: {
            width: 0,
            height: 0
          }
        },
        default: {
          // https://github.com/necolas/react-native-web/issues/44
          // Material Design
          boxShadow: 'none'
        }
      })
    },
    headerTitleAlign: 'center',
    // headerTransparent: true,
    cardStyle: {
      backgroundColor: colors.darkCharcoal
    },
    // smooth card transitions on Android to avoid white flash
    ...Platform.select({
      android: {
        cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
        transitionSpec: {
          open: TransitionSpecs.TransitionIOSSpec,
          close: TransitionSpecs.TransitionIOSSpec,
        },
      },
      default: {}
    })
  }
}

export const tabsNavigationProps = {
  // renderScene
  // initialRouteName="Addons"
  tabBarOptions: {
    tabBarActiveTintColor: colors.brightOrange,
    tabBarInactiveTintColor: colors.brightOrange + 75,
    tabBarStyle: {
      backgroundColor: colors.darkCharcoal,
      borderTopWidth: 0,
      paddingBottom: 10,
      // paddingLeft: 5,
      // paddingRight: 5,
      borderTopColor: 'transparent',
      // ...adaptive.bottomNavigationBarHeight,
      ...Platform.select({
        android: {

        },
        ios: {
          paddingTop: 10,
        }
      }),
    },
    labelStyle: {
      fontFamily: typography.defaultFontFamily,
      fontWeight: '500',
      ...adaptive.navigationBarFontSize
    },
    tabBarLabelPosition: 'below-icon'
  }
}
